import b from 'b_';
import qs from 'query-string';
import React, { useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { Button } from '../button/button';
import { UI_KIT_HEADER_TYPOGRAPHY } from '../constants';
import { H4 } from '../header-text/header-text';
import { SimpleText } from '../simple-text/simple-text';

import { QuizStudentGame } from './__game/quiz-student__game';
import QuizStudentWrapper, { QUIZ_STUDENT_THEME } from './__wrapper/quiz-student__wrapper';

import './quiz-student.scss';

interface QueryParamsType {
    room?: string;
}

export const QuizStudent = () => {
    const { search } = useLocation();
    const queryParams = useMemo<QueryParamsType>(() => qs.parse(search), [search]);
    const roomNumber = queryParams?.room;

    const [pin, setPin] = useState(roomNumber || '');
    const inputRef = useRef<HTMLInputElement>(null);

    if (pin) {
        return <QuizStudentGame pin={pin} />;
    }

    return (
        <QuizStudentWrapper theme={QUIZ_STUDENT_THEME.START}>
            <div className="quiz-student__section-wrapper">
                <div className={b('quiz-student__section', { start: true })}>
                    <H4
                        id="quiz.educationYandexQuiz"
                        mix="quiz-student__education-yandex-quiz-title"
                        typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}
                    />
                    <H4
                        id="quiz.headerNewTitle"
                        mix="quiz-student__section-title"
                        typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}
                    />
                    <H4 id="quiz.instructions.enterNewPin" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSRegular} />
                    <input className="quiz-student__pin-input" ref={inputRef} type="number" />
                    <Button
                        className="quiz-student__enter-button"
                        onClick={() => {
                            setPin(inputRef.current!.value);
                        }}
                        rounded
                        view={Button.VIEW.ACTION}
                    >
                        <SimpleText id="quiz.action.enterRoom" />
                    </Button>
                    <H4
                        id="quiz.instructions.howGetCode"
                        mix="quiz-student__how-get-code"
                        typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSRegular}
                    />
                </div>
            </div>
        </QuizStudentWrapper>
    );
};
